export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-900 text-center mb-3">
          关于牛牛
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-8 md:mb-10 max-w-xl mx-auto">
          以技术驱动观影，让每个人都能享受流畅的影视时光
        </p>
        <div className="bg-background-50 rounded-2xl p-6 md:p-10">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
            牛牛影视创立于热爱电影的一群技术人。我们深知追剧时遇到缓冲转圈的烦躁，也理解画质模糊带来的观影遗憾。因此，我们倾力打造了牛牛超清引擎与牛牛不缓冲技术，从底层编码到分发网络全面优化，让每一帧画面都以极清品质流畅呈现。
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
            平台现收录超过12万部影视资源，涵盖电影、电视剧、纪录片、动漫等全品类内容。我们坚持免费开放、无需注册的原则，让每一位观众都能零门槛享受高品质的在线观影体验。牛牛极清模式下，4K超清画质配合零缓冲播放，为你还原影院级的沉浸感受。
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            未来，牛牛影视将持续优化播放技术、丰富内容片库、完善多端体验，让「不卡顿、超清看」成为每一位用户的日常。感谢选择牛牛，和我们一起，享受纯粹的观影快乐。
          </p>
        </div>
      </div>
    </section>
  );
}